import React, { Component } from 'react';

export default (WrappedComponent) => {
  class Buttonized extends Component {
    static displayName = `buttonized(${
      WrappedComponent.displayName || WrappedComponent.name
    })`;

    onKeyPress = (event) => {
      if (event.which === 13 && this.element && this.element.click) {
        this.element.click();
      }
    };

    saveRef = (ref) => {
      this.element = ref;
    };

    render() {
      return (
        <WrappedComponent
          role="button"
          onKeyPress={this.onKeyPress}
          tabIndex="0"
          ref={this.saveRef}
          {...this.props}
        />
      );
    }
  }

  return Buttonized;
};
